
import { Component, Prop, Vue } from 'vue-property-decorator';
import { State, Action } from 'vuex-class';
import { UserResource } from '@/api/requests/types';
import VueAvatar from 'vue-avatar';

@Component({
    components: { VueAvatar },
})
export default class AppMenuAccount extends Vue {
    @State user!: UserResource;
    @Action resetAuth: any;

    @Prop({ type: Boolean, default: false })
    readonly collapsed!: boolean;

    @Prop({ type: Boolean, default: false })
    readonly disabled!: boolean;

    private isOpen = false;

    async signOut() {
        // Logout.
        this.resetAuth();
        // Redirect.
        this.$router.push({ name: 'login' });
    }

    private close() {
        this.isOpen = false;
    }

    private open() {
        if (this.disabled) {
            return;
        }
        this.isOpen = true;
    }
}
